import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  const languages = [
    { code: "en", name: "English", flag: "🇺🇸" },
    { code: "tr", name: "Türkçe", flag: "🇹🇷" },
  ];

  const changeLanguage = (language: string) => {
    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set("lang", language);
    window.location.assign(nextUrl.toString());
  };

  return (
    <details className="group relative">
      <summary
        className="flex h-10 w-10 cursor-pointer list-none items-center justify-center rounded-full transition-colors hover:bg-secondary/10 hover:text-secondary [&::-webkit-details-marker]:hidden"
        aria-label={t("language.switch")}
      >
        <Globe className="h-5 w-5" aria-hidden="true" />
        <span className="sr-only">{t("language.switch")}</span>
      </summary>
      <div className="absolute right-0 top-12 z-50 w-32 overflow-hidden rounded-lg border border-secondary/20 bg-white/95 p-1 shadow-lg backdrop-blur-sm">
        {languages.map(language => (
          <button
            key={language.code}
            type="button"
            onClick={() => changeLanguage(language.code)}
            className={`flex w-full items-center rounded-md px-2 py-2 text-left text-sm transition-colors hover:bg-secondary/10 ${
              i18n.language === language.code
                ? "bg-secondary/10 font-medium text-secondary"
                : "text-primary"
            }`}
            aria-current={i18n.language === language.code ? "true" : undefined}
          >
            <span className="mr-2" aria-hidden="true">
              {language.flag}
            </span>
            {language.name}
          </button>
        ))}
      </div>
    </details>
  );
}
